import { render, staticRenderFns } from "./OldTransaction.vue?vue&type=template&id=261cf32f&"
import script from "./OldTransaction.vue?vue&type=script&lang=js&"
export * from "./OldTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports